<template lang="html">
  <div class="settingsForm">
    <!-- SPECIFIC SETTINGS -->
    <div
      v-if="specificOriginModel.length !== 0"
      :class="['block-setting', {'on-preview': isOnPreview()}]"
    >
      <!--<header class="with-button">-->
      <!--<h2>Template {{ templateName | capitalize }}</h2>-->
      <!--<button-->
      <!--type="button"-->
      <!--class="reset"-->
      <!--@click="resetConfig">-->
      <!--reset-->
      <!--</button>-->
      <!--</header>-->
      <setting-form-item
        v-for="setting in specificOriginModel"
        :key="`settingOrigin_${setting.name}`"
        :type="setting.type"
        :name="`${setting.type}_${setting.name}`"
        :label="setting.label"
        :i18nkey="setting.i18nkey"
        :is-required="setting.required"
        :is-specific="true"
      >
        <setting-input
          v-model="specific.origin[setting.name]"
          :name="`${setting.type}_${setting.name}`"
          :type="setting.type"
          :default-value="setting.value"
          :focus="setting.focus"
          :placeholder="setting.placeholder"
          :validation="setting.validation"
          :required="setting.required"
          :max-length="setting.maxlength"
          :valuei18nkeys="setting.valuei18nkeys"
        />
      </setting-form-item>
      <button
        type="button"
        class="send-preview"
        @click="debouncedSendPreview()"
      >
        <div class="progress" />
        <span class="UI-icon UI-play" />
        {{ $t('ui.previsualize') }}
      </button>
    </div>

    <div
      v-if="localesAllowed && localesAllowed.length > 0"
      class="block-setting"
    >
      <header>
        <h2>{{ $t('ui.titles.languages') }}</h2>
      </header>
      <!-- ADD LOCALE -->
      <div
        class="setting-select-wrapper"
      >
        <span class="UI-icon UI-expand" />
        <select
          v-model="lastLocaleAdded"
          :disabled="Object.keys(specific.translations).length === localesAllowed.length"
          class="add-locale setting-input"
        >
          <option
            disabled
            value=""
          >
            {{ $t('ui.add-translation') }}
          </option>
          <option
            v-for="locale in localesAllowed"
            :key="`locale_${locale}`"
            :disabled="Object.keys(specific.translations).includes(locale)"
            :value="locale"
          >
            {{ locale }}
          </option>
        </select>
      </div>
    </div>

    <!-- LOCALE SETTINGS -->
    <div
      v-if="Object.keys(specific.translations).length !== 0"
    >
      <div
        v-for="locale in Object.keys(specific.translations)"
        :ref="`locale-setting-${locale}`"
        :key="`tr_${locale}`"
        :class="['translation', 'block-setting', {'on-preview': isOnPreview(locale)}]"
      >
        <header class="no-border">
          <h3>{{ $t('ui.translation') | capitalize }} - {{ locale.toUpperCase() }}</h3>
        </header>

        <setting-form-item
          v-for="setting in specificTranslationsModel"
          :key="`trs_${locale}_${setting.name}`"
          :type="setting.type"
          :name="`${locale}_${setting.type}_${setting.name}`"
          :label="setting.label"
          :i18nkey="setting.i18nkey"
          :is-specific="true"
        >
          <setting-input
            v-model="specific.translations[locale][setting.name]"
            :name="`${locale}_${setting.name}`"
            :type="setting.type"
            :default-value="setting.value"
            :placeholder="setting.placeholder"
            :i18nvalue="setting.i18nvalue"
            :required="setting.required"
            :valuei18nkeys="setting.valuei18nkeys"
            :locale="locale"
          />
        </setting-form-item>

        <div
          :class="{rtl : locale === 'ar'}"
          class="wrapper-button"
        >
          <button
            type="button"
            class="delete-setting"
            @click="removeLocale(locale)"
          >
            <span class="UI-icon UI-close" />
          </button>
          <button
            type="button"
            class="send-preview"
            @click="debouncedSendPreview(locale)"
          >
            <div class="progress" />
            <span class="UI-icon UI-play" />
          </button>
        </div>
      </div>
    </div>

    <!-- general SETTINGS -->
    <div
      v-if="general.length !== 0"
      class="general-setting block-setting"
    >
      <header>
        <h2>{{ $t('ui.titles.file-settings') }}</h2>
      </header>

      <setting-form-item
        v-for="setting in generalModel"
        :key="`setting_${setting.name}`"
        :name="`${setting.type}_${setting.name}`"
        :type="setting.type"
        :label="setting.label"
        :i18nkey="setting.i18nkey"
      >
        <setting-input
          v-model="general[setting.name]"
          :name="`${setting.type}_${setting.name}`"
          :type="setting.type"
          :default-value="setting.value"
          :values-associated="setting.valuesAssociated"
          :valuei18nkeys="setting.valuei18nkeys"
          :required="setting.required"
        />
      </setting-form-item>
    </div>

    <!-- CONFIGS -->
    <div
      v-if="configs.length !== 0"
      class="configs"
    >
      <header>
        <h2>{{ $t('ui.titles.recap') }}</h2>
      </header>
      <div class="configs-details">
        <!--        {{ $t('ui.recapSentence', {-->
        <!--          videoCount:configs.length,-->
        <!--          videoGeneration: $tc('ui.videoGeneration', configs.length),-->
        <!--          sendToIris: general.sendToIris && general.sendToIris !== 'none' ? ' ' + $tc(`ui.recapIris-${general.sendToIris}`, configs.length) : '',-->
        <!--          resolution: `${general.videoWidth} x ${general.videoHeight}`,-->
        <!--          fps: general.fps,-->
        <!--          codec: general.codec,-->
        <!--          format: general.fileFormat-->
        <!--        }) }}-->
        <!--        {{ $n(configs.length) }}-->
        <!--        <span>{{ $n(configs.length) }}</span>-->
        <!--        <span v-if="general.sendToIris && general.sendToIris !== 'none'"> {{ $tc(`ui.recapIris-${general.sendToIris}`, configs.length) }}</span>-->
        <!--        <span>{{ `${general.videoWidth} x ${general.videoHeight}` }}</span>-->
        <!--        <span>{{ general.fps }}</span>-->
        <!--        <span>{{ general.codec }}</span>-->
        <!--        <span>{{ general.fileFormat }}</span>-->
        <i18n
          path="ui.recapSentence"
          tag="p"
          class="recap-sentence"
        >
          <template v-slot:videoCount>
            <span class="bold">{{ $n(configs.length) }}</span>
          </template>
          <template v-slot:videoGeneration>
            <span>{{ $tc('ui.videoGeneration', configs.length) }}</span>
          </template>
          <template
            v-if="general.sendToIris && general.sendToIris !== 'none'"
            v-slot:sendToIris
          >
            <span class="bold"> {{ $tc(`ui.recapIris-${general.sendToIris}`, configs.length) }}</span>
          </template>
          <template v-slot:resolution>
            <span class="bold">{{ `${general.videoWidth} x ${general.videoHeight}` }}</span>
          </template>
          <template v-slot:fps>
            <span class="bold">{{ general.fps }}</span>
          </template>
          <template v-slot:codec>
            <span class="bold">{{ general.codec }}</span>
          </template>
          <template v-slot:format>
            <span class="bold">{{ general.fileFormat }}</span>
          </template>
        </i18n>
        <ul>
          <li
            v-for="details in configs"
            :key="`details_${details.specific.locale || 'VO'}`"
          >
            <span>• {{ details.specific.locale ? $t(`ui.recap.${details.specific.locale}`) + ` (+ ${ $t('ui.translation') })` : Array.isArray(details.specific.defaultLocale) ? '' : $t(`ui.recap.${details.specific.defaultLocale}`) }}</span>
            <button
              v-if="details.specific.locale"
              type="button"
              class="delete-setting small"
              @click="removeLocale(details.specific.locale)"
            >
              <span class="UI-icon UI-close" />
            </button>
          </li>
        </ul>
      </div>
      <div class="validate">
        <button
          type="button"
          class="validate-config"
          @click="debouncedValidate()"
        >
          <span class="UI-icon UI-checked" />
          {{ $t('ui.generate') }} {{ configs.length }} {{ $tc('ui.videos', configs.length) }}
          <span v-if="general.sendToIris && general.sendToIris !== 'none'">{{ $tc(`ui.andSendToIris-${general.sendToIris}`, configs.length) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { VIDEO_TITLE, FILE_FORMAT, FPS_PRESETS, GENERAL_MODEL, NUMBER } from '@/config'
import SettingFormItem from '@/components/SettingFormItem'
import SettingInput from '@/components/SettingInput'
import bus from '@/bus'
import dayjs from 'dayjs'
import debounce from 'lodash.debounce'
import { customAlphabet } from 'nanoid'

export default {
  name: 'SettingsForm',

  components: { SettingFormItem, SettingInput },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  props: {
    templateName: { type: String, required: true },
    specificOriginModel: { type: Array, required: true },
    specificTranslationsModel: { type: Array, required: true },
    localesAllowed: { type: Array, default: _ => [] },
    templateUrl: { type: String, required: true }
  },

  data () {
    return {
      specific: {
        origin: {},
        translations: {}
      },
      general: {
        timestamp: new Date().getTime(),
        fileFormat: ''
      },
      lastLocaleAdded: '',
      defaultFilename: '',
      localeOnPreview: undefined
    }
  },

  computed: {
    generalModel () {
      const gm = GENERAL_MODEL
      const setting = gm.find(m => m.name === VIDEO_TITLE)
      if (setting !== undefined) {
        setting.value = this.defaultFilename
      }
      return gm
        .filter(m => {
          // Active conditionnal inputs (dimensions, fps, ...)
          return m.dependsOn === undefined || this.general[m.dependsOn] === gm.find(a => a.name === m.dependsOn).displayDependenciesWhen
        })
    },

    configs () {
      const result = []
      result.push(this.generateconfigsEntry())
      Object.keys(this.specific.translations).map(locale => {
        result.push(this.generateconfigsEntry(locale))
      })

      return result
    },

    debouncedSendPreview () {
      return debounce(this.sendPreview, 1500, {
        leading: true,
        trailing: false
      })
    },

    debouncedValidate () {
      return debounce(this.validate, 1500, {
        leading: true,
        trailing: false
      })
    }
  },

  watch: {
    lastLocaleAdded (newValue) {
      if (newValue.length === 0) return
      this.addLocale(newValue)
      this.lastLocaleAdded = ''
      this.$nextTick(_ => {
        this.autoScroll(this.$refs[`locale-setting-${newValue}`][0])
      })
    },

    'general.exportPresets' (preset) {
      // Set fileFormat and codec according to export presets
      this.general.fileFormat = preset.split('—')[1].trim()
      this.general.codec = preset.split('—')[0].trim()

      // If not mxf, do not send to IRIS
      if (!preset.includes('mxf')) this.general.sendToIris = 'none'
    },

    'general.fileFormat' (format) {
      let fpsOptions = []
      switch (format) {
        case 'mxf':
          fpsOptions = ['25']
          break
        default:
          fpsOptions = ['25', '50']
          break
      }
      this.generalModel.find(setting => setting.name === FPS_PRESETS).value = fpsOptions
    }
  },

  created () {
    this.dynamicDataBinding(this.generalModel, this.general)
    this.dynamicDataBinding(this.specificOriginModel, this.specific.origin)
    this.dynamicDataWatching(
      'general',
      GENERAL_MODEL.filter(m => m.displayDependenciesWhen !== undefined),
      GENERAL_MODEL.filter(m => m.dependsOn !== undefined)
    )
  },

  mounted () {
    this.addEventListeners()
  },

  beforeDestroyed () {
    this.removeEventListeners()
  },

  methods: {
    addEventListeners () {
      bus.$on('default-filename', this.updateDefaultFilename)
      bus.$on('preview-progress', this.updateProgressPreviewButton)
      bus.$on('reset-config', this.resetConfig)

      bus.$on('geocode-place-selected', this.setLatLon)
    },

    removeEventListeners () {
      bus.$off('default-filename', this.updateDefaultFilename)
      bus.$off('preview-progress', this.updateProgressPreviewButton)
      bus.$off('reset-config', this.resetConfig)

      bus.$off('geocode-place-selected', this.setLatLon)
    },

    autoScroll (elem) {
      const elScrollOffset = elem.getBoundingClientRect().top
      const scrollOffset = window.pageYOffset || document.documentElement.scrollTop
      const padding = 12
      const target = elScrollOffset + scrollOffset - padding
      window.scrollTo({
        top: target,
        behavior: 'smooth'
      })
      window.onscroll = e => {
        const currentScrollOffset = window.pageYOffset || document.documentElement.scrollTop
        if (currentScrollOffset === target) {
          window.onscroll = null // remove listener
        }
      }
    },

    updateDefaultFilename (payload) {
      this.defaultFilename = payload
    },

    updateProgressPreviewButton (progress) {
      document.querySelector('.on-preview .send-preview .progress').style.width = `${progress * 100}%`
    },

    dynamicDataBinding (propertiesArray, instanceObject) {
      propertiesArray.map(prop => {
        this.$set(instanceObject, prop.name, prop.value)
      })
    },

    dynamicDataWatching (namespace, propertiesArray, dependencies) {
      propertiesArray.map(prop => {
        this.$watch(`general.${prop.name}`, newVal => {
          let values = []
          prop.separator ? values = newVal.split(prop.separator) : values.push(newVal)
          if (values.length > 1 || values[0] !== prop.displayDependenciesWhen) {
            prop.dependenciesOrder.map((d, i) => {
              const dModel = dependencies.find(dep => dep.name === d)
              if (dModel && dModel.replacesDependentValue === true) { // Only replace according values if 'replacesDependentValue' is true
                const v = dModel.type === NUMBER ? parseFloat(values[i]) : values[i]
                this[namespace][d] = v
              } else if (!dModel) {
                console.warn(`no dependencies model found for "${d}" in dynamicDataWatching for "${prop.name}"`)
              }
            })
          } else {
            // value = custom, do what you want here
          }
        })
      })
    },

    resetConfig () {
      Object.keys(this.specific.translations).map(l => this.removeLocale(l))
    },

    addLocale (locale) {
      this.$set(this.specific.translations, locale, {})
      this.dynamicDataBinding(this.specificTranslationsModel, this.specific.translations[locale])
    },

    removeLocale (locale) {
      this.$delete(this.specific.translations, locale)
    },

    generateconfigsEntry (locale = null) {
      return {
        general: {
          ...this.general,
          filename: this.generateFilename(locale),
          host: this.templateUrl
        },
        specific: {
          locale: locale,
          ...this.specific.origin,
          ...Object.assign(
            ...this.specificTranslationsModel.map(spe => {
              return {
                [spe.name]: locale !== null ? this.specific.translations[locale][spe.name] : null
              }
            })
          )
        }
      }
    },

    generateFilename (locale = null) {
      // Start with human readable date + time (local zone)
      let filename = `${dayjs().format('YYYYMMDD_HHmmss')}`

      // Add video title according to template. If no title, add template name
      if (this.general[VIDEO_TITLE]) {
        filename += '_' + this.general[VIDEO_TITLE]
          .replace(/[àáâãäå]/g, 'a')
          .replace(/[èéêë]/g, 'e')
          .replace(/[ïîì]/g, 'i')
          .replace(/[öôòõ]/g, 'o')
          .replace(/[üûùú]/g, 'u')
          .replace(/[ÿ]/g, 'y')
          .replace(/[œ]/g, 'oe')
          .replace(/[/\\:]/g, '-')
          .replace(/\s/g, '_')
          .replace(/[^a-z0-9-_]/gi, '')
      } else {
        filename += `_${this.templateName}`
      }

      // Add language version of the video
      filename += `_${locale || 'vo'}`

      // Add a 6 characters random id to highly mitigate collision risk. See https://zelark.github.io/nano-id-cc/
      // 6 is quite enough for current configuration (only part of filename + files older than 15 days are deleted)
      const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-', 6)
      filename += `_${nanoid()}`

      // Add fileformat
      filename += `.${this.general[FILE_FORMAT]}`

      return filename.trim().toLowerCase()
    },

    sendPreview (locale = null) {
      const previousProgress = document.querySelector('.on-preview .send-preview .progress')
      if (previousProgress !== null) previousProgress.style.width = 0
      const requiredElement = this.checkRequired()
      if (requiredElement) {
        bus.$emit('highlight-errors', requiredElement)
        return
      }
      this.general.timestamp = new Date().getTime()
      this.localeOnPreview = locale
      bus.$emit('previsualize', this.configs.find(entry => entry.specific.locale === locale))
    },

    isOnPreview (version = null) {
      return this.localeOnPreview === version
    },

    // Check for all required inputs. Return the first required input not filled.
    checkRequired () {
      const required = document.querySelectorAll('.settingsForm *[required=required]')
      let i = 0
      let stop = false
      while (i < required.length && !stop) {
        stop = required[i].value === '' || required[i].value === null
        i++
      }
      return stop ? required[i - 1].parentElement : false
    },

    validate () {
      const requiredElement = this.checkRequired()
      if (requiredElement) {
        bus.$emit('highlight-errors', requiredElement)
        return
      }
      this.general.timestamp = new Date().getTime()
      var jobs = this.configs.map(c => ({ data: c }))
      this.$emit('validate', jobs)
      this.autoScroll(document.getElementById('result-anchor'))
    },

    setLatLon (value) {
      if (!value || !value.latitude || !value.longitude) return
      this.specific.origin.latitude = value.latitude
      this.specific.origin.longitude = value.longitude

      if (this.specificOriginModel.find(setting => setting.name === 'latitude')) {
        this.specificOriginModel.find(setting => setting.name === 'latitude').value = value.latitude
      }

      if (this.specificOriginModel.find(setting => setting.name === 'longitude')) {
        this.specificOriginModel.find(setting => setting.name === 'longitude').value = value.longitude
      }

      this.setDefaultMapLabels(value)
    },

    setDefaultMapLabels (value) {
      if (!value || !value.name || !value.name.split(', ').length < 0) return
      const splitName = value.name.split(', ')
      const str = splitName.length > 1 ? `${splitName[0]}` : splitName[0]
      // const str = splitName.length > 1 ? `${splitName[0]}, ${splitName[splitName.length - 1]}` : splitName[0] // <-- LOCATION, COUNTRY
      if (this.specificOriginModel.find(setting => setting.name === 'globeLocation')) {
        this.specificOriginModel.find(setting => setting.name === 'globeLocation').value = str
      }

      if (this.specificOriginModel.find(setting => setting.name === 'label')) {
        this.specificOriginModel.find(setting => setting.name === 'label').value = splitName[0]
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/styles/variables";
@import "~@/assets/styles/buttons";

.settingsForm{

  .on-preview{

    .send-preview{
      position: relative;
      z-index: 1;
      background: rgba(255, 255, 255, 0.5);

      .progress{
        transition: width 150ms;
        position: absolute;
        height: 100%;
        background: $green;
        top: 0;
        left: 0;
        z-index: -1;
        border-radius: inherit;
      }
    }
  }

  .block-setting{
    margin-bottom: 24px;

    &.translation{
      padding-bottom: 24px;
    }
  }

  .add-locale{ display: block; }

  button{
    @extend %reset-button;
    border-radius: 5px;
    color: white;
    text-shadow: 0 1px 0 rgba(black, 0.2);
    padding: 14px 16px;
    font-size: $f16;
    .UI-icon{
      line-height: 0;
      font-size: 22px;
      vertical-align: middle;
    }

    &.reset{
      &:hover{
        background: white
      }
    }

    &.send-preview{
      background: $green;
      margin-top: 14px;
    }

    &.delete-setting{
      background: rgba(0, 0, 0, 0.15);
      &:hover{
        transition: background 175ms;
        background: #d09237;
      }
    }

    &.validate-config{
      background: $red;
    }

    &.small{
      min-width: 36px;
      min-height: 36px;
      padding: 0;
    }

    & + button{
      margin-left: 18px;
    }
  }

  .configs-details{
    color: #A2b4b4;

    .recap-sentence{
      span.bold { color: white }
    }

    ul, li{
      padding: 0; margin: 0;
    }

    li{
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 40px;
    }
    margin-bottom: 24px;
  }

  .validate{
    margin: 12px 0 24px 0;
  }
}
.wrapper-button{
  margin-top: 18px;
  &.rtl{
    direction: rtl;
    .send-preview{
      margin-right: 18px;
    }
  }
}
</style>
